<template>
	<div class="user">
		<userMenu></userMenu>
		<div class="user-wraps">
			<div class="user-main">
				<div class="user-infob">
					<div class="infob-left">
						<div class="infob-img">
							<img :src="userInfo.avatar">
						</div>
						<div class="infob-in">
							<h3>
								Hi，{{userInfo.nickname}}
								<span>
									{{userInfo.account}}
								</span>
							</h3>
							<p>
								会员等级：{{lvData[userInfo.level]}}
								<a style="color: var(--color);margin-left: 20px;">提升等级</a>
							</p>
							<p>
								注册时间：{{userInfo.create_time}}
							</p>
						</div>
					</div>
					<div class="infob-right"></div>
				</div>
				<div class="user-data">
					<div class="user-title">
						北域视界 AI 词条数据汇总
					</div>
					<div class="user-data-item">
						<dl v-for="item in numData">
							<dt>{{item.count}}</dt>
							<dd>{{numName[item.pid]}}</dd>
						</dl>
					</div>
				</div>
			</div>
			<!-- <div class="user-infoa">
				<div class="user-avatar">
					<img :src="userInfo.avatar">
				</div>
				<div class="ue-name">
					{{userInfo.nickname}}
				</div>
				<div class="ue-tip">
					<div class="ue-tip-icon">
						<i class="el-icon-house"></i>
					</div>
					<div class="ue-tip-icon">
						<i class="el-icon-message"></i>
					</div>
					<div class="ue-tip-icon">
						<i class="el-icon-bell"></i>
					</div>
					<div class="ue-tip-icon"  @click="setPwd">
						<i class="el-icon-setting"></i>
					</div>
					<div class="ue-tip-icon" @click="logout">
						<i class="el-icon-switch-button"></i>
					</div>
				</div>
				<div class="ue-vip">
					<div class="ue-ico">
						<i class="el-icon-s-promotion"></i>
					</div>
					<div class="ue-in">
						<div class="ue-in-lst">
							会员等级：{{lvData[userInfo.level]}}
						</div>
						<div class="ue-in-lsts">
							注册时间：{{userInfo.create_time}}
						</div>
					</div>
				</div>
				<div class="ue-buy">
					<div class="ue-buy-lf">
						<div class="ue-buy-mon">
							<div class="ue-buy-name">
								<span>￥</span>
								88.00
							</div>
							<div class="ue-buy-ro2">
								<div class="ue-ro2-n1"></div>
								<div class="ue-ro2-n2"></div>
								<div class="ue-ro2-txt">
									限时
								</div>
							</div>
						</div>
					</div>
					<div class="ue-buy-rg">
						<h4>年费VIP会员</h4>
						<p>限时骨折 机不可失</p>
						<div class="ue-buy-ro"></div>
					</div>
				</div>
			</div> -->
		</div>
		<el-dialog title="修改登录密码" :visible.sync="pwdPup" width="500px">
			<div class="pup-pwd">
				<div class="pup-item">
					<el-input size="small" type="password" show-password v-model="oldpwd" prefix-icon="el-icon-news" placeholder="请输入旧密码"></el-input>
				</div>
				<div class="pup-item">
					<el-input size="small" type="password" show-password v-model="setpwd" prefix-icon="el-icon-mobile" placeholder="请输入新密码"></el-input>
				</div>
				<div class="pup-item">
					<el-input size="small" type="password" show-password v-model="setpwd2" prefix-icon="el-icon-mobile" placeholder="再次输入密码"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="pwdPup = false">取 消</el-button>
				<el-button size="small" type="primary" @click="savePwd">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import userMenu from '@/page/public/userMenu'
	import api from '@/api/api'
	export default {
		components: {
			userMenu: userMenu
		},
		data() {
			return {
				userInfo: '',
				lvData: ['', '注册用户', '月费会员', '特邀会员', '年费会员', '管理员', '超级管理员'],
				numData:[],
				numName:['','商业商用提示词','人像人物绘画','场景概念原画','国风中式美学','3D 质感材质渲染','治愈萌系绘本','胶片纪实摄影','小众艺术风格'],
				pwdPup:false,
				oldpwd:'',
				setpwd:'',
				setpwd2:''
			}
		},
		methods: {
			savePwd(){
				if(this.oldpwd==''){
					this.$message.error('请输入旧密码');
					return
				}
				if(this.setpwd==''){
					this.$message.error('请输入新密码');
					return
				}else{
					if(this.setpwd.length<6){
						this.$message.error('输入的新密码太简单');
						return
					}
				}
				if(this.setpwd2==''){
					this.$message.error('请再次输入新密码');
					return
				}else{
					if(this.setpwd!==this.setpwd2){
						this.$message.error('两次输入的新密码不一致');
						return
					}
				}
				let params = {
					token:api.getCookie('token'),
					oldPwd:this.oldpwd,
					setpwd:this.setpwd
				}
				api.setUserPassword(params).then(res=>{
					if(res.code==200){
						this.$message.success(res.msg);
						api.delCookie('token');
						this.$router.push("/login");
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			setPwd(){
				this.pwdPup = true;
			},
			logout() {
				this.$confirm('确定要退出登录？', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					api.delCookie('token');
					this.$router.push("/login");
				}).catch(() => {

				});
			},
			getMemberInfo() {
				let params = {
					token: api.getCookie('token')
				}
				api.getMemberInfo(params).then(res => {
					if (res.code == 200) {
						this.userInfo = res.data;
					}else if(res.code==401){
						api.delCookie('token');
						this.$router.push("/login");
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			getNumberBycat(){
				let params = {}
				api.getNumberBycat(params).then(res=>{
					this.numData = res.data;
				})
			}
		},
		created() {
			this.getMemberInfo();
			this.getNumberBycat();
		}
	}
</script>

<style>
	.infob-in h3{
		margin: 0;
		line-height: 50px;
		font-size: 20px;
		padding-bottom: 10px;
	}
	.infob-in h3 span{
		font-weight: normal;
		font-size: 14px;
		color: #666;
		padding-left: 20px;
	}
	.infob-in p{
		margin: 0;
		line-height: 25px;
		font-size: 13px;
		color: #666;
	}
	.infob-in{
		flex: 1;
	}
	.infob-img{
		width: 120px;
		height: 120px;
		background-color: #fff;
		border-radius: 50%;
		outline: 2px solid rgba(0,0,0,.2);
		outline-offset: 3px;
		margin-right: 20px;
	}
	.infob-img img{
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
		border-radius: 50%;
	}
	.infob-left{
		display: flex;
		width: 600px;
		padding: 40px;
		background-color: #fff;
		border-radius: 10px;
	}
	.infob-right{
		flex: 1;
		width: 0;
		background-color: #fff;
		margin-left: 20px;
		border-radius: 10px;
	}
	.user-infob{
		display: flex;
		margin: 20px;
	}
	.user-title{
		font-size: 18px;
		padding-bottom: 20px;
	}
	.user-data-item dl dd{
		margin: 0;
		text-align: center;
		font-size: 14px;
		color: #999;
		padding-top: 10px;
	}
	.user-data-item dl dt{
		text-align: center;
		font-family: 'numfont';
		font-size: 24px;
	}
	.user-data-item dl{
		margin: 0;
		background-color: #fff;
		border-radius: 10px;
		padding: 20px;
	}
	.user-data-item{
		display: grid;
		gap: 20px;
		grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
	}
	.user-data{
		margin: 20px;
	}
	.pup-item{
		padding: 10px 0;
	}
	.pup-pwd{
		padding: 0 20px;
	}
	
	.ue-ro2-txt {
		position: relative;
		z-index: 9;
		top: 10px;
		left: 37px;
		width: 0;
		height: 50px;
		font-size: 12px;
		padding-top: 6px;
		padding-left: 10px;
		color: rgba(255, 121, 78, 1);
		border-left: 1px dashed #ffbca6;
	}

	.ue-ro2-n1,
	.ue-ro2-n2 {
		position: relative;
		z-index: 9;
		top: 30px;
		left: 30px;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: #ffbca6;
	}

	.ue-ro2-n2 {
		top: 66px;
	}

	.ue-buy-name span {
		position: relative;
		font-size: 14px;
		top: -10px;
		left: 5px;
	}

	.ue-buy-name {
		position: relative;
		z-index: 9;
		width: 100px;
		height: 50px;
		line-height: 48px;
		font-size: 29px;
		padding-left: 5px;
		background-color: #fff;
		font-family: 'numfont';
		color: rgba(255, 121, 78, 1);
		font-weight: bold;
	}

	.ue-buy-mon {
		position: relative;
		z-index: 9;
		width: 102%;
		height: 50px;
		margin: 10px;
		border-radius: 7px;
		overflow: hidden;
	}

	.ue-buy-ro2 {
		position: absolute;
		right: 0;
		top: -75%;
		width: 70px;
		height: 126px;
		background-color: #fff;
		border-radius: 0 150px 150px 0;
	}

	.ue-buy-ro {
		position: absolute;
		top: -40%;
		left: -57px;
		width: 70px;
		height: 126px;
		background-color: #ffbca6;
		border-radius: 0 150px 150px 0;
	}

	.ue-buy-lf {
		flex: 1;
	}

	.ue-buy-rg p {
		margin: auto;
		font-size: 12px;
		color: #fff;
	}

	.ue-buy-rg h4 {
		margin: 0;
		color: #fff;
		line-height: 25px;
		font-size: 19px;
		padding-top: 15px;
	}

	.ue-buy-rg {
		position: relative;
		width: 150px;
		text-align: center;
		background-color: rgba(255, 121, 78, 1);
		border-radius: 0 10px 10px 0;
		overflow: hidden;
	}

	.ue-buy {
		display: flex;
		width: 100%;
		height: 70px;
		background-color: #ffbca6;
		border-radius: 10px;
		box-sizing: border-box;
		margin-top: 15px;
	}

	.ue-in {
		flex: 1;
		font-size: 12px;
		padding-left: 10px;
	}

	.ue-in-lst {
		line-height: 20px;
	}

	.ue-in-lsts {
		line-height: 20px;
	}

	.ue-ico {
		width: 40px;
		height: 40px;
		background-color: rgba(255, 255, 255, 1);
		border-radius: 5px;
		text-align: center;
		line-height: 40px;
		font-size: 30px;
		color: #162635;
	}

	.ue-vip {
		display: flex;
		width: 100%;
		height: 70px;
		background-color: #162635;
		color: #ffbe7c;
		margin-top: 10px;
		border-radius: 10px;
		box-sizing: border-box;
		padding: 15px;
	}

	.ue-tip {
		display: flex;
		margin-top: 20px;
		margin-bottom: 30px;
		justify-content: center;
	}

	.ue-tip-icon {
		width: 40px;
		height: 40px;
		background-color: var(--bg3);
		line-height: 40px;
		text-align: center;
		margin: 0 5px;
		border-radius: 5px;
		color: #666;
		cursor: pointer;
	}

	.ue-tip-icon:hover {
		background-color: #0f5bff;
		color: #fff;
	}

	.ue-name {
		text-align: center;
		font-size: 16px;
		padding-top: 30px;
		font-weight: bold;
	}

	.user-avatar {
		width: 150px;
		height: 150px;
		border-radius: 50%;
		background-color: #fff;
		overflow: hidden;
		box-sizing: border-box;
		border: 8px solid var(--bg3);
		margin: 100px auto 0 auto;
	}

	.user-avatar img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.user-main {
		flex: 1;
		background-color: var(--bg3);
	}

	.user-infoa {
		width: 350px;
		height: 100vh;
		background-color: #fff;
		box-sizing: border-box;
		padding: 0 30px;
	}

	.user-wraps {
		display: flex;
		width: 100%;
		padding-left: 220px;
		box-sizing: border-box;
	}
	.user{
		width: 100%;
		height: 100vh;
		background-color: var(--bg3);
	}
	
	/* .el-button--primary {
		background-color: var(--color);
		border-color: var(--color);
	}
	
	.el-button--primary:hover {
		background-color: var(--color2);
		border-color: var(--color2);
	} */
</style>



// WEBPACK FOOTER //
// src/page/member.vue